import { ref } from 'vue'

export default () => ({
  maintenance: ref({ active: false, message: null, startsAt: null, endsAt: null }),
  // Only advanced by the scheduled-start timer, so getters comparing against
  // startsAt re-evaluate at the moment a scheduled window opens.
  now: ref(Date.now())
})
